export class CakeOrder {
    constructor({id, date, time, firstName, lastName, phoneNumber, cakeSize, filling1, filling2,
        color, message, image, comments, cashier, createdAt, ready=false, imageReady=false, imageUrl=null, createdImageUrl=null, store_id, prePaid, customerId=null, imageNeeded=true}) {
        this.id = id;
        this.date = date;
        this.time = time;
        this.firstName = firstName;
        this.lastName = lastName;
        this.phoneNumber = phoneNumber;
        this.cakeSize = cakeSize;
        this.filling1 = filling1;
        this.filling2 = filling2;
        this.color = color;
        this.message = message;
        this.image = image;
        this.comments = comments;
        this.cashier = cashier;
        this.createdAt = createdAt;
        this.ready = ready;
        this.imageReady = imageReady;
        this.imageUrl = imageUrl;
        this.createdImageUrl = createdImageUrl; // URL of the created/printed image
        this.store_id = store_id;
        this.prePaid = prePaid || false; // Default to false if not provided
        this.customerId = customerId; // Link to customer record
        this.imageNeeded = imageNeeded;
    }


    toJson() {
        return {
            id: this.id,
            date: this.date,
            time: this.time,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            cakeSize: this.cakeSize,
            filling1: this.filling1,
            filling2: this.filling2,
            color: this.color,
            message: this.message,
            image: this.image,
            comments: this.comments,
            cashier: this.cashier,
            createdAt: this.createdAt,
            store_id: this.store_id,
            ready: this.ready || false,
            imageReady: this.imageReady || false,
            imageUrl: this.imageUrl || null,
            createdImageUrl: this.createdImageUrl || null,
            imageNeeded: this.imageNeeded !== undefined ? this.imageNeeded : true,
            prePaid: this.prePaid || false,
            customerId: this.customerId || null,
        };
    }

    static fromFirebase(doc) {
        const data = doc.data();
        return new CakeOrder({
            id: doc.id,
            date: data.date,
            time: data.time,
            firstName: data.firstName,
            lastName: data.lastName,
            phoneNumber: data.phoneNumber,
            cakeSize: data.cakeSize,
            filling1: data.filling1,
            filling2: data.filling2,
            color: data.color,
            message: data.message,
            image: data.image,
            comments: data.comments,
            cashier: data.cashier? data.cashier : '👀‼️ Hecho por Cliente. COBRAR AL ENTREGAR ‼️👀',
            createdAt: data.createdAt,
            ready: data.ready,
            imageReady: data.imageReady,
            imageUrl: data.imageUrl,
            createdImageUrl: data.createdImageUrl || null,
            imageNeeded: data.imageNeeded !== undefined ? data.imageNeeded : true,
            store_id: data.store_id,
            prePaid: data.prePaid? data.prePaid : false, // Default to false if not provided
            customerId: data.customerId || null
        });
    }


}
